import styled from '@emotion/styled';
import React from 'react';
import ReactDOM from 'react-dom';
import {
	BrowserRouter as Router,
	Redirect,
	Route,
	Switch
} from 'react-router-dom';
import Faq from './pages/Faq';
import Help from './pages/Help';
import Legal from './pages/Legal';
import {
	BrandDetailsProvider,
	BrandThemeProvider,
	useBrandDetails
} from 'dw-au-react-components';
import { FaqProvider } from './context/FaqProvider';
import ScrollToTop from './utils/ScrollToTop';

const StyledMainWrapper = styled.div`
	background: #fafafa;
`;

const MainLayout = ({ children }) => {
	const brandData = useBrandDetails();
	return (
		<StyledMainWrapper className={brandData.tag}>{children}</StyledMainWrapper>
	);
};

let brandTag = 'wpe';

const App = () => {
	let pathPrefix = '/jsp/customerservice/common/customerservice.jsp';

	return (
		<BrandDetailsProvider brandTag={brandTag}>
			<BrandThemeProvider brandTag={brandTag}>
				<FaqProvider>
					<MainLayout>
						<Router>
							<ScrollToTop />
							<Switch>
								<Route exact path={['/customer-services', pathPrefix]}>
									<Help />
								</Route>
								<Route exact path='/customer-services/faq'>
									<Redirect to='/customer-services/faq/wine-plans' />
								</Route>
								<Route exact path='/customer-services/faq/:section/:question?'>
									<Faq />
								</Route>
								<Route exact path='/customer-services/legal/:section'>
									<Legal />
								</Route>
							</Switch>
						</Router>
					</MainLayout>
				</FaqProvider>
			</BrandThemeProvider>
		</BrandDetailsProvider>
	);
};

ReactDOM.render(<App />, document.getElementById('customer_service'));
